import WeddingEventReviewStepUpdateModal, {
  WEDDING_EVENT_CREATE_REVIEW_STEP_UPDATE_MODAL,
} from './modal';

export { WEDDING_EVENT_CREATE_REVIEW_STEP_UPDATE_MODAL };

export default WeddingEventReviewStepUpdateModal;
